// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3IdHO","colMaxWidth":"Table_colMaxWidth__2eYuH"};